// extracted by mini-css-extract-plugin
export default {"wrapper":"nav-item-module--wrapper--b36a2","active":"nav-item-module--active--131f4","text":"nav-item-module--text--a11ef"};